const applyLoader = require('./loader');
const post = require('./post');

let loader = null;

function initSubmitHandler() {
    document.querySelector('.contact-form').addEventListener('submit', async e => {
        e.preventDefault();

        if (loader !== null) {
            return;
        }

        const date = new Date();
        const dateSum =
            date.getUTCFullYear() + date.getUTCMonth() + 1 + date.getUTCDate() + date.getUTCHours();
        const answer = !(dateSum % 2) ? 'yes' : 'no';
        const xyz = Object(Object(document.querySelector('.xyz')).dataset).xyz;
        const name = Object(document.querySelector('.contact-form input[name=name]')).value;
        const surname = Object(document.querySelector('.contact-form input[name=surname]')).value;
        const email = Object(document.querySelector('.contact-form input[name=email]')).value;
        const iam = Object(document.querySelector('.contact-form select[name=iam]')).value;
        const message = Object(
            document.querySelector('.contact-form textarea[name=message]')
        ).value;
        const submitButton = document.querySelector('.contact-form button[type=submit]');
        const uri = document.querySelector('#contact-form-uri').dataset.uri;

        loader = applyLoader(submitButton);

        const response = Object(
            await post(uri, {
                name,
                surname,
                email,
                iam,
                message,
                answer,
                xyz
            })
        );

        loader.release();
        loader = null;

        const formWrapper = document.querySelector('.contact-form-box');
        while (formWrapper.firstChild) {
            formWrapper.removeChild(formWrapper.lastChild);
        }

        const messageNode =
            response.success && response.xyz
                ? document.querySelector('#contact .success-message')
                : document.querySelector('#contact .error-message');

        messageNode.style.removeProperty('display');
        formWrapper.appendChild(messageNode);
    });
}

function rand(length, characters) {
    let result = '';
    var len = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * len));
    }
    return result;
}

module.exports = {
    initSubmitHandler
};
